import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import { searchContent } from '@plone/volto/actions/search/search';

const ImageGalleryView = ({ pathname, location, isEditMode }) => {
  const folderPath = pathname
    ? pathname.replace(/\/edit$/, '')
    : location?.pathname;
  const dispatch = useDispatch();
  const images = useSelector(
    (state) => state?.search?.subrequests?.images?.items,
  );
  React.useEffect(() => {
    dispatch(
      searchContent(
        folderPath,
        {
          'path.depth': 2,
          portal_type: 'Image',
        },
        'images',
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const gallery_id = 'photoswipeGallery';
  // const [items, setItems] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: '#' + gallery_id,
      children: isEditMode ? 'span' : 'a',
      pswpModule: PhotoSwipe,
    });
    lightbox.init();
    setLightbox(lightbox);

    return () => {
      lightbox.destroy();
      // lightbox = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="pswp-gallery" id={gallery_id}>
      {images?.map((image, index) => (
        <a
          href={`${
            image['@id'] +
            '/' +
            (image?.image_scales?.image?.[0]?.scales?.larger?.download
              ? image?.image_scales?.image?.[0]?.scales?.larger?.download
              : image.image_scales.image[0]?.download)
          }`}
          data-pswp-width={
            image?.image_scales?.image?.[0]?.scales?.larger?.width
              ? image?.image_scales?.image?.[0]?.scales?.larger?.width
              : image.image_scales.image[0].width
          }
          data-pswp-height={
            image?.image_scales?.image?.[0]?.scales?.larger?.height
              ? image?.image_scales?.image?.[0]?.scales?.larger?.height
              : image.image_scales.image[0].height
          }
          key={index}
          // onClick={openViewer}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={`${
              image['@id'] +
              '/' +
              (image?.image_scales?.image?.[0]?.scales?.preview?.download
                ? image?.image_scales?.image?.[0]?.scales?.preview?.download
                : image.image_scales.image[0].scales.mini?.download)
            }`}
            alt=""
            loading="lazy"
          />
        </a>
      ))}
    </div>
  );
};

export default ImageGalleryView;
